module.exports = __webpack_public_path__ + "img/inbox-green.ff7208f6.svg";